import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { questions, scenarios } from '../../data/content';
export function Problem() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-283" data-mp="2rnvfiehpkeaq">
      <div className="mx-auto max-w-3xl" data-id="element-284" data-mp="2rmaj0jbu2la8">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-285" data-mp="2mptuvp4mw6x5">
          You Have the Observations. <span className="text-brand" data-id="element-286" data-mp="2hrio5n9mycj5">But Do You Have a Clear Plan?</span>
        </h2>

        <div className="mt-10 space-y-3" data-id="element-287" data-mp="2cpkwq5r30bf4">
          {scenarios.map(s => <p key={s} className="border-l-4 border-brand bg-brand-light px-4 py-3 text-[17px] font-medium text-navy" data-id="element-288" data-mp="28qkhex7tbqwv">
              {s}
            </p>)}
        </div>

        <p className="mt-8 text-lg text-navy/80" data-id="element-289" data-mp="6yplbpy1huzr">
          You recognize that motor planning may be contributing to the difficulties. <strong className="text-navy" data-id="element-290" data-mp="204l3qisfbbb">But then comes the challenging part.</strong>
        </p>
        <p className="mt-3 font-display text-xl font-extrabold text-navy" data-id="element-291" data-mp="14a0mq1benf12">How do you turn those observations into a structured intervention plan?</p>

        <div className="mt-6 rounded-2xl bg-navy p-5 sm:p-7" data-id="element-292" data-mp="197sgz1zivd8f">
          <p className="text-sm font-semibold text-brand-soft" data-id="element-293" data-mp="vboxo3q6spaq">You may find yourself asking:</p>
          <ul className="mt-4 space-y-3" data-id="element-294" data-mp="10a9qvj70u8po">
            {questions.map(q => <li key={q} className="flex gap-3 text-[16px] text-white" data-id="element-295" data-mp="1nyt1i5djmxkx">
                <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-296" data-mp="1s0ek87cre631" />
                {q}
              </li>)}
          </ul>
        </div>

        <div className="mt-8 space-y-4 text-lg text-navy/80" data-id="element-297" data-mp="1e7f2rztf21su">
          <p data-id="element-298" data-mp="1j71f871f7e0l">Without a consistent planning structure, each new case can require rebuilding your workflow.</p>
          <p data-id="element-299" data-mp="26wc7t18ma23n">Your assessment findings may be detailed, but the connection between observations, goals, activities, and progress measures can remain unclear.</p>
          <p className="font-display text-xl font-extrabold text-navy" data-id="element-300" data-mp="2lkvuko1m4jha">
            The solution isn't another collection of motor development theory. It's a practical system that helps you organize the information you already collect.
          </p>
        </div>

        <SectionCTA label="Turn My Observations Into a Plan" data-id="element-301" data-mp="2bo9cu84l28jh" />
      </div>
    </section>;
}